import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PcmpUrgentBatchPrintPage } from '@/features/pcmp/pages/PcmpUrgentBatchPrintPage';

export const Route = createFileRoute('/_print/pcmp/requests/batches/$batchNo/print')({
  parseParams: ({ batchNo }) => {
    const parsedNo = Number(batchNo);
    if (!Number.isInteger(parsedNo) || parsedNo <= 0) throw notFound();
    return { batchNo: parsedNo };
  },
  component: () => (
    <ErrorBoundary moduleName="PCMP Urgent Batch Report">
      <PcmpUrgentBatchPrintPage />
    </ErrorBoundary>
  ),
});
